import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import BackgroundImage from "../../assets/images/authentication-background.jpeg";
import HandshakeImage from "../../assets/images/hand-shake.png";
import ElephantImage from "../../assets/images/elephant.png";

const AuthContainer = ({ children }) => {
  const { palette } = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "auto", md: "100vh" },
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        // padding: 10,
      }}
    >
      <Box
        sx={{
          background: palette.gradient.background,
          position: "relative",
          minHeight: { md: "90vh" },
          margin: "auto",
          width: { xs: "100%", sm: "90%" },
          borderRadius: { xs: "0px", sm: "30px" },
        }}
      >
        <Grid container>
          <Grid item xs={12} md={5} p={2}>
            <Stack gap={1.5} direction={"row"} alignItems={"center"}>
              <img
                src={ElephantImage}
                alt={"hand-shake-image"}
                width={80}
                height={"auto"}
              />
              <Box>
                <Typography
                  variant="h1"
                  fontSize={"1.5rem"}
                  color={"secondary.light"}
                  fontWeight={600}
                >
                  Trust <span style={{ fontWeight: 300 }}>Business</span>
                </Typography>
                <Typography
                  variant="body2"
                  color={"secondary.light"}
                  fontWeight={600}
                >
                  Powered By softflux
                </Typography>
              </Box>
            </Stack>
            <Stack mt={{ xs: 2, sm: 8 }} gap={2}>
              <Typography
                variant="h1"
                fontSize={"2rem"}
                color={"secondary.light"}
                fontWeight={600}
              >
                Connecting You with Confidence
              </Typography>
              <Typography
                variant="body1"
                color={"secondary.light"}
                fontWeight={300}
              >
                Trust Business delivers reliable and seamless communication
                solutions. Stay connected with our top-notch services designed
                for your business and personal needs.
              </Typography>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              height: { md: "90vh" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              backgroundColor: palette.secondary.light,
              borderRadius: { md: "30px 30px 30px 30px" },
            }}
          >
            <Container
              maxWidth={"sm"}
              sx={{ maxWidth: "500px !important", py: "20px" }}
            >
              {children}
            </Container>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AuthContainer;
